/**
 * Keeps Wishlist Hero buttons pinned in place when toggled.
 * The app can inject inline left/right styles on state change.
 * Also offsets the wishlist page/modal below the fixed header.
 */
(function () {
  const CARD_SELECTOR = '.card-product-new__wishlist';
  const PRODUCT_SELECTOR = '[id^="MainProduct-"] #wishlist-hero-product-page-button';
  const PRODUCT_TITLE_SELECTOR = '[id^="MainProduct-"] .product__title';
  const ICON_COLOR = '#211e1f';
  const PAGE_OFFSET_CLASS = 'wishlist-page-below-header';
  const MARKER_RE = /share wishlist|my wishlist|remove all from wishlist|add all to cart/i;

  function setImportant(el, prop, value) {
    if (
      el.style.getPropertyValue(prop) === value &&
      el.style.getPropertyPriority(prop) === 'important'
    ) {
      return;
    }
    el.style.setProperty(prop, value, 'important');
  }

  function styleWishlistIcon(icon) {
    if (!icon) return;

    setImportant(icon, 'width', '20px');
    setImportant(icon, 'height', '18px');
    setImportant(icon, 'margin', '0px');
    setImportant(icon, 'padding', '0px');
    setImportant(icon, 'padding-top', '0px');
    setImportant(icon, 'font-size', '18px');
    setImportant(icon, 'display', 'block');
    setImportant(icon, 'flex-shrink', '0');
    setImportant(icon, 'overflow', 'visible');
    setImportant(icon, 'fill', ICON_COLOR);
    setImportant(icon, 'color', ICON_COLOR);
    setImportant(icon, 'opacity', '1');

    icon.querySelectorAll('path, circle, rect, polygon, use').forEach((shape) => {
      shape.removeAttribute('fill');
      shape.removeAttribute('stroke');
      setImportant(shape, 'fill', ICON_COLOR);
      setImportant(shape, 'stroke', ICON_COLOR);
      setImportant(shape, 'opacity', '1');
    });
  }

  function styleWishlistButton(button, isCard) {
    if (!button) return;

    setImportant(button, 'position', 'relative');
    setImportant(button, 'top', 'auto');
    setImportant(button, 'right', 'auto');
    setImportant(button, 'left', 'auto');
    setImportant(button, 'margin', '0px');
    setImportant(button, 'padding', '0px');
    setImportant(button, 'width', '32px');
    setImportant(button, 'height', '32px');
    setImportant(button, 'min-width', '32px');
    setImportant(button, 'max-width', '32px');
    setImportant(button, 'float', 'none');
    setImportant(button, 'overflow', 'visible');
    setImportant(button, 'display', 'flex');
    setImportant(button, 'align-items', 'center');
    setImportant(button, 'justify-content', 'center');
    setImportant(button, 'box-sizing', 'border-box');
    setImportant(button, 'color', ICON_COLOR);
    setImportant(button, 'opacity', '1');
    setImportant(button, 'box-shadow', 'none');
    setImportant(button, 'outline', 'none');

    setImportant(button, 'border', 'none');
    setImportant(button, 'border-radius', '0');
    setImportant(button, 'background', 'transparent');
  }

  function pinElement(el, config, isCard) {
    if (!el) return;

    setImportant(el, 'position', 'absolute');
    setImportant(el, 'top', config.top);
    setImportant(el, 'right', config.right);
    setImportant(el, 'left', 'auto');
    setImportant(el, 'bottom', 'auto');
    setImportant(el, 'margin', '0px');
    setImportant(el, 'margin-right', '0px');
    setImportant(el, 'float', 'none');
    setImportant(el, 'width', '32px');
    setImportant(el, 'height', '32px');
    setImportant(el, 'min-width', '32px');
    setImportant(el, 'max-width', '32px');
    setImportant(el, 'padding', '0px');
    setImportant(el, 'transform', 'none');

    el.querySelectorAll(
      'button, .wlh-button, .wlh-collection-button, [data-wlh-id], .wishlist-hero-custom-button'
    ).forEach((button) => styleWishlistButton(button, isCard));

    el.querySelectorAll('svg, .wlh-svg-Icon, [class*="wlh-svg"]').forEach(styleWishlistIcon);
  }

  function pinWishlistButtons() {
    observer.disconnect();

    document.querySelectorAll(CARD_SELECTOR).forEach((el) => {
      pinElement(el, { top: '16px', right: '16px' }, true);
    });

    document.querySelectorAll(PRODUCT_SELECTOR).forEach((container) => {
      pinElement(container, { top: '0px', right: '0px' }, false);
      container
        .querySelectorAll('.wishlist-hero-custom-button, .wlh-button, button, [data-wlh-id]')
        .forEach((el) => {
          pinElement(el, { top: '0px', right: '0px' }, false);
        });
    });

    document.querySelectorAll(PRODUCT_TITLE_SELECTOR).forEach((title) => {
      title
        .querySelectorAll('.wlh-button, [data-wlh-id], .wishlist-hero-custom-button, button')
        .forEach((el) => {
          styleWishlistButton(el, false);
          el.querySelectorAll('svg, .wlh-svg-Icon, [class*="wlh-svg"]').forEach(styleWishlistIcon);
        });
    });

    observeWishlistRegions();
  }

  function schedulePin() {
    requestAnimationFrame(pinWishlistButtons);
    window.setTimeout(pinWishlistButtons, 50);
    window.setTimeout(pinWishlistButtons, 200);
    window.setTimeout(pinWishlistButtons, 500);
    window.setTimeout(pinWishlistButtons, 1000);
  }

  document.addEventListener('DOMContentLoaded', schedulePin);
  document.addEventListener('click', (event) => {
    if (event.target.closest(`${CARD_SELECTOR}, ${PRODUCT_SELECTOR}, ${PRODUCT_TITLE_SELECTOR}`)) {
      schedulePin();
    }
  }, true);

  document.addEventListener('wishlist-hero-add-to-custom-element', schedulePin);

  function isWishlistNode(node) {
    return (
      node instanceof Element &&
      (node.matches(
        `${CARD_SELECTOR}, ${PRODUCT_SELECTOR}, ${PRODUCT_TITLE_SELECTOR}, ${CARD_SELECTOR} button, ${CARD_SELECTOR} .wlh-button, ${PRODUCT_SELECTOR} button, ${PRODUCT_SELECTOR} .wlh-button, ${PRODUCT_SELECTOR} .wishlist-hero-custom-button, ${PRODUCT_TITLE_SELECTOR} [data-wlh-id], ${PRODUCT_TITLE_SELECTOR} .wlh-button`
      ) ||
        node.closest(CARD_SELECTOR) ||
        node.closest(PRODUCT_SELECTOR) ||
        node.closest(PRODUCT_TITLE_SELECTOR))
    );
  }

  const observer = new MutationObserver((mutations) => {
    const shouldPin = mutations.some((mutation) => {
      if (mutation.type === 'attributes') {
        return isWishlistNode(mutation.target);
      }

      if (mutation.type === 'childList') {
        return [...mutation.addedNodes, ...mutation.removedNodes].some(isWishlistNode);
      }

      return false;
    });

    if (shouldPin) schedulePin();
  });

  function observeWishlistRegions() {
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'fill', 'stroke'],
    });
  }

  document.addEventListener('DOMContentLoaded', observeWishlistRegions);
  document.addEventListener('shopify:section:load', schedulePin);

  let pageOffsetTimers = [];
  let applyingPageOffset = false;

  function getHeaderClearance() {
    const pill = document.querySelector('.custom-header-pill');
    const header = document.querySelector('.section-header');
    const target = pill || header;
    if (!target) return 130;

    const bottom = Math.ceil(target.getBoundingClientRect().bottom);
    return Math.max(bottom + 24, 110);
  }

  function setClearanceVar() {
    document.documentElement.style.setProperty(
      '--wishlist-header-clearance',
      getHeaderClearance() + 'px'
    );
  }

  function isVisible(el) {
    if (!(el instanceof Element)) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function findWishlistPageRoot() {
    const nodes = document.querySelectorAll('h1, h2, button, a, span, p');
    let marker = null;

    for (const node of nodes) {
      if (!isVisible(node)) continue;
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 80) continue;
      if (MARKER_RE.test(text)) {
        marker = node;
        break;
      }
    }

    if (!marker) {
      return (
        document.querySelector('#hero-wishlist') ||
        document.querySelector('[id*="hero-wishlist"]') ||
        document.querySelector('[class*="wishlist-hero-modal"]') ||
        document.querySelector('[class*="wishlisthero-modal"]') ||
        document.querySelector('[class*="wlh-modal"]')
      );
    }

    let el = marker;
    let best = marker;

    while (el && el !== document.body) {
      const style = window.getComputedStyle(el);
      const fixedLike = style.position === 'fixed' || style.position === 'absolute';
      const coversViewport =
        el.clientHeight >= window.innerHeight * 0.5 ||
        el.getBoundingClientRect().height >= window.innerHeight * 0.5;

      if (fixedLike && coversViewport) {
        return el;
      }

      if (coversViewport) best = el;
      el = el.parentElement;
    }

    return best;
  }

  function findWishlistTitle(root) {
    if (!root) return null;
    const nodes = root.querySelectorAll('h1, h2, h3, span, div, p');
    for (const node of nodes) {
      if (!isVisible(node)) continue;
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 40) continue;
      if (/my wishlist/i.test(text)) return node;
    }
    return null;
  }

  function offsetWishlistPage() {
    if (applyingPageOffset) return;
    applyingPageOffset = true;

    try {
      const desiredTop = getHeaderClearance();
      setClearanceVar();

      const root = findWishlistPageRoot();

      document.querySelectorAll(`.${PAGE_OFFSET_CLASS}`).forEach((el) => {
        if (el !== root) {
          el.classList.remove(PAGE_OFFSET_CLASS);
          el.style.removeProperty('padding-top');
        }
      });

      if (!root || !isVisible(root)) return;

      root.classList.add(PAGE_OFFSET_CLASS);

      /* Measure title vs header, then add only the missing space */
      const title = findWishlistTitle(root);
      const currentPadding = parseFloat(window.getComputedStyle(root).paddingTop) || 0;
      let nextPadding = desiredTop;

      if (title) {
        const titleTop = title.getBoundingClientRect().top;
        const deficit = desiredTop - titleTop;
        nextPadding = Math.max(0, currentPadding + deficit);
      }

      const clearance = `${Math.round(nextPadding)}px`;
      if (
        root.style.getPropertyValue('padding-top') !== clearance ||
        root.style.getPropertyPriority('padding-top') !== 'important'
      ) {
        root.style.setProperty('padding-top', clearance, 'important');
      }
    } finally {
      applyingPageOffset = false;
    }
  }

  function schedulePageOffset() {
    pageOffsetTimers.forEach((id) => window.clearTimeout(id));
    pageOffsetTimers = [50, 250, 800].map((delay) =>
      window.setTimeout(offsetWishlistPage, delay)
    );
  }

  document.addEventListener('DOMContentLoaded', schedulePageOffset);
  window.addEventListener('hashchange', schedulePageOffset);
  window.addEventListener('resize', () => {
    setClearanceVar();
    offsetWishlistPage();
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('a[href="#hero-wishlist"], .wishlist-hero-header-icon')) {
      schedulePageOffset();
    }
  }, true);

  const pageObserver = new MutationObserver((mutations) => {
    if (applyingPageOffset) return;

    const relevant = mutations.some((mutation) => {
      if (mutation.type !== 'childList') return false;
      return [...mutation.addedNodes].some((node) => {
        if (!(node instanceof Element)) return false;
        const id = (node.id || '').toLowerCase();
        const cls = (node.className && String(node.className).toLowerCase()) || '';
        return (
          id.includes('wishlist') ||
          id.includes('wlh') ||
          cls.includes('wishlist') ||
          cls.includes('wlh') ||
          MARKER_RE.test(node.textContent || '')
        );
      });
    });

    if (relevant || window.location.hash === '#hero-wishlist') {
      schedulePageOffset();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    pageObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
